import React from 'react';
import { useTranslation } from 'react-i18next';

function TopBar({ title, actions }) {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng);
  };

  return (
    <div className="topbar" style={{
      height: '70px',
      backgroundColor: 'rgba(26, 26, 26, 0.8)',
      backdropFilter: 'blur(10px)',
      borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 2rem',
      width: '100%',
      maxWidth: '100vw',
      overflow: 'hidden'
    }}>
      <h1 style={{
        fontSize: 'clamp(1.1rem, 3vw, 1.5rem)',
        fontWeight: '700',
        color: 'white',
        margin: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        flex: 1,
        minWidth: 0
      }}>
        {title}
      </h1>

      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: '0.75rem',
        flexShrink: 0
      }}>
        {actions}
        
        {/* Language Selector - Compact on mobile */}
        <div style={{
          display: 'flex',
          gap: '0.25rem',
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
          padding: '0.25rem',
          borderRadius: '8px',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <button
            onClick={() => changeLanguage('es')}
            data-testid="lang-es"
            style={{
              padding: 'clamp(0.4rem, 2vw, 0.5rem) clamp(0.6rem, 3vw, 1rem)',
              border: 'none',
              borderRadius: '6px',
              background: i18n.language === 'es' ? 'rgba(168, 85, 247, 0.8)' : 'transparent',
              color: 'white',
              fontWeight: i18n.language === 'es' ? '600' : '400',
              fontSize: '0.875rem',
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
          >
            🇪🇸 Español
          </button>
          <button
            onClick={() => changeLanguage('ca')}
            data-testid="lang-ca"
            style={{
              padding: 'clamp(0.4rem, 2vw, 0.5rem) clamp(0.6rem, 3vw, 1rem)',
              border: 'none',
              borderRadius: '6px',
              background: i18n.language === 'ca' ? 'rgba(168, 85, 247, 0.8)' : 'transparent',
              color: 'white',
              fontWeight: i18n.language === 'ca' ? '600' : '400',
              fontSize: '0.875rem',
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
          >
            🏴 Català
          </button>
        </div>
      </div>
    </div>
  );
}

export default TopBar;